import { SmtpSettingsComponent } from './components/smtp-settings/smtp-settings.component';
import { AppContainerComponent } from './components/navigation-container/navigation-container.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { LegalComponent } from './components/legal/legal.component';
import { InputLimiterDirective } from './directives/input-limiter.directive';
import { SPHPhone } from './model/sph-phone.model';
import { MenuEntry } from './components/main-menu/menu-entry';
import { SPHLoggedInUser } from './model/sph-logged-in-user.model';
import { SPHLicense, SPHApplication } from './model/sph-license.model';
import { LicenseManagerService } from './licensemanager-service/licensemanager.service';
import { SPHUser } from './model/sph-user.model';
import { SPHCompany } from './model/sph-company.model';
import { MainMenuComponent } from './components/main-menu/main-menu.component';

const SHARED_COMPONENTS = [MainMenuComponent, PrivacyComponent, LegalComponent, AppContainerComponent, SmtpSettingsComponent];
const SHARED_DIRECTIVES = [InputLimiterDirective];

const SHARED_MODELS: any[] = [SPHCompany, SPHUser, SPHLicense];
const SHARED_PROVIDERS = [LicenseManagerService];

export {
    SHARED_MODELS,
    SHARED_PROVIDERS,
    SHARED_COMPONENTS,
    SHARED_DIRECTIVES,

    MainMenuComponent,
    LegalComponent,
    PrivacyComponent,
    AppContainerComponent,
    SmtpSettingsComponent,

    SPHCompany,
    SPHUser,
    SPHLicense,
    SPHLoggedInUser,
    SPHApplication,
    SPHPhone,

    MenuEntry,

    LicenseManagerService,

    InputLimiterDirective
};



// WEBPACK FOOTER //
// ./src/app/features/shared/shared.ts